module.exports = "<div e-chart=\"container\" class=\"pie-chart-size\" ng-class=\"$ctrl.chartClass\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/echartPieChart.component.html
// module id = 1305
// module chunks = 0